import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/constants/testIds";

const faqs = [
  { q: "What services do you offer?", a: "SEO, AEO, GEO, Google Ads, Meta Ads, LinkedIn marketing, email marketing, performance marketing, lead generation, AI marketing automation, landing page optimization, content strategy, and analytics." },
  { q: "Who is this agency best for?", a: "Small and medium businesses, startups, coaches, consultants, education, real estate, travel, D2C, e-commerce and service-based companies that want more traffic, leads and conversions." },
  { q: "What is included in the free growth audit?", a: "A review of your website performance, SEO visibility, keyword opportunities, Google and Meta Ads gaps, landing page issues, lead funnel, content gaps and AI automation opportunities." },
  { q: "Do you handle both SEO and paid ads?", a: "Yes. I run integrated campaigns combining organic SEO and paid media (Google, Meta, LinkedIn) for compounding growth." },
  { q: "Can you help with AI marketing automation?", a: "Yes — CRM workflows, lead follow-ups, reporting dashboards, email lifecycle automation, and AI-assisted content and analytics." },
  { q: "How soon can I expect results?", a: "Paid ads typically show early signals within 2–4 weeks. Meaningful SEO growth usually shows over 3–6 months and compounds from there." },
  { q: "Do you provide monthly reports?", a: "Yes. You get clean, executive-ready monthly reports with KPIs, wins, learnings and next steps." },
  { q: "Do you work with small businesses?", a: "Absolutely. I have flexible plans tailored to small businesses as well as scaling brands." },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid={FAQ.section} className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="text-center reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">FAQ</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-12 reveal">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-slate-200 rounded-2xl mb-3 px-5 data-[state=open]:border-blue-200 data-[state=open]:bg-blue-50/30"
              >
                <AccordionTrigger
                  data-testid={FAQ.item(i)}
                  className="text-left font-display font-semibold text-slate-900 text-base md:text-lg hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm md:text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
